import { getJSON } from '@/services/httpService';

export const getUuid = () => getJSON('/util/uuid');
